import styled, { css } from 'styled-components';
import { colours } from 'styling/colours';

export const ButtonStyledAsLink = styled.button`
  padding: 0;
  background: none;
  outline: none;
  border: none;
  text-decoration: underline;
  color: ${colours.link};
  font-weight: 600;
  font-family: 'MuseoSans';

  &:hover {
    cursor: pointer;
  }
  &:focus-visible {
    outline: 1px solid ${colours.secondary};
    outline-offset: 1px;
  }
`;

export const ButtonResetCss = css`
  padding: 0;
  background: none;
  outline: none;
  border: none;
`;
